<template>
  <div class="about-us">
    <v-card class="common-card lighten-4">
      <h4 class="shopDeeppurple--text fs-xxlarge">راهنمای خرید</h4>
      <v-row class="d-flex flex-row">
        <v-col cols="12" xl="8" lg="8" md="8" sm="7" xs="12">
          <div class="items-buyGuide">
            <h1 class="shopDeeppurple--text">مرحله اول:</h1>
            <h5 class="mt-3 mainFont--text">
              کتاب‌های مورد نظر خود را انتخاب کرده و به سبد خرید خود اضافه
              نمایید.
            </h5>
          </div>
          <div class="items-buyGuide">
            <h1 class="shopDeeppurple--text">مرحله دوم:</h1>

            <h5 class="mt-3 mainFont--text">
              به سبد خرید خود مراجعه نموده و مراحل پرداخت را طی کنید.
            </h5>
          </div>
          <div class="items-buyGuide">
            <h1 class="shopDeeppurple--text">مرحله سوم:</h1>
            <h5 class="mt-3 mainFont--text">
              کتاب‌های مورد نظر شما به درب آدرس انتخابی شما ارسال شده و به شما
              تحویل داده می‌شوند.
            </h5>
          </div>
        </v-col>
        <v-col cols="12" xl="4" lg="4" md="4" sm="5" xs="12"> </v-col>
      </v-row>
      <v-row class="video-box">
        <v-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <div class="video-help-buy">
            <h1 class="shopDeeppurple--text">ویدیوی آموزش فرایند خرید</h1>
          </div>
        </v-col>
        <v-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <div class="video-player">
            <video controls>
              <source src="../../assets/images/helpby.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Helpbuy",
  metaInfo() {
    return {
      title: `راهنمای خرید| کتاب باز`, // Meta title
      meta: [
        {
          name: "description",
          content: "راهنمای خرید از فروشگاه آنلاین کتاب باز", // Meta description
        },
        {
          property: "og:title", // Open Graph meta tag
          content: "راهنمای خرید",
        },
        {
          property: "og:description",
          content: "راهنمای خرید از فروشگاه آنلاین کتاب باز",
        },
      ],
    };
  },
  beforeDestroy() {
    // Reset the meta title when leaving the page
    document.title = "کتاب باز"; // Replace with your default title
    // Optionally, remove any other meta tags
    const metaTags = document.querySelectorAll(
      "meta[data-vue-router-controlled]"
    );
    metaTags.forEach((tag) => tag.parentNode.removeChild(tag));
  },
};
</script>

<style lang="scss">
.video-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
}

.video-help-buy {
  display: flex;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 18px;
    font-weight: bolder;
  }
}
.video-player {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.video-player video {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  width: 800px;
  @media only screen and (max-width: 900px) {
    width: 500px;
  }
  @media only screen and (max-width: 600px) {
    width: 300px;
  }
}
.about-us {
  overflow: hidden;
  .common-card {
    position: relative;
    min-height: 300px;
    @media only screen and (max-width: 600px) {
      padding-bottom: 250px !important;
    }
    .image-box {
      position: absolute;
      left: 30px;
      width: 200px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      @media only screen and (max-width: 600px) {
        left: 10px;
      }
    }
  }
}
.items-buyGuide {
  margin-top: 10px;
  h1 {
    font-size: 16px;
    font-weight: bolder;
  }
  h5 {
    font-size: 14px;
  }
}
</style>
